import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedModule } from '../shared/shared.module';
import { NewAgencyModule } from './admin/agencies/new/new-agency.module';
import { PortalRoutingModule } from './portal-routing.module';
import { PortalComponent } from './portal.component';
import { PortalResolve } from './portal.resolve';
import { AgGridModule } from 'ag-grid-angular';
import { HomePageComponent } from './home-page/home-page.component';

@NgModule({
  imports: [
    CommonModule,
    PortalRoutingModule,
    FlexLayoutModule.withConfig({ useColumnBasisZero: false }),
    SharedModule,
    NewAgencyModule,
    AgGridModule
  ],
  declarations: [PortalComponent, HomePageComponent],
  exports: [PortalComponent],
  providers: [PortalResolve]
})
export class PortalModule {}
